import { isNil } from 'lodash/fp'

import { UrlBuilder } from '@masterplandev/utils'

const learnpathUrl = UrlBuilder()
  .template('/:prefix/:learnpathId/:infix/:elementId/:topic/:lecture/:suffix')
  .addParam({ prefix: 'learnpaths' })

const channelSlugUrl = UrlBuilder()
  .template('/:prefix/:channel/:topic/:lecture/:suffix')
  .addParam({ prefix: 'channel' })

const lecturesSlugUrl = UrlBuilder()
  .template('/:prefix/:topic/:lecture/:suffix')
  .addParam({ prefix: 'lectures' })

const skillSlugUrl = UrlBuilder()
  .template('/:prefix/:skill/:topic/:lecture/:suffix')
  .addParam({ prefix: 'skill' })

const courseSlugUrl = UrlBuilder()
  .template('/:prefix/:course/:topic/:lecture/:suffix')
  .addParam({ prefix: 'course-generic' })

interface BuildLectureLinkParams {
  channel?: string
  course?: string
  elementId?: string
  hash?: string
  infix?: string
  learnpathId?: string
  lecture?: string
  prefix?: string
  query?: Record<string, any>
  skill?: string
  suffix?: string | null
  topic?: string
}

export default function buildLectureLink({
  channel,
  course,
  elementId,
  hash,
  infix,
  learnpathId,
  lecture,
  prefix,
  query = {},
  skill,
  suffix: originalSuffix,
  topic,
}: BuildLectureLinkParams): string {
  // Adding suffix without lecture or element generates invalid lecture link.
  const suffix = isNil(lecture ?? elementId) ? null : originalSuffix

  // Parameter lecture and topic are both used also in context of learnpaths for
  // masterplan content.
  const commonParams = { prefix, topic, lecture, suffix }

  let urlCreator
  if (course) {
    urlCreator = courseSlugUrl.addParam({
      ...commonParams,
      course,
    })
  } else if (channel) {
    urlCreator = channelSlugUrl.addParam({
      ...commonParams,
      channel,
    })
  } else if (learnpathId) {
    // For learnpath we can have app URL '/learnpaths/:learnpathId/:elementId'
    // or redux store api URL '/learnpaths/:learnpathId/elements/:elementId'
    // and this is why dynamic infix is required.
    urlCreator = learnpathUrl.addParam({
      ...commonParams,
      learnpathId,
      infix,
      elementId,
    })
  } else if (skill) {
    urlCreator = skillSlugUrl.addParam({
      ...commonParams,
      skill,
    })
  } else {
    urlCreator = lecturesSlugUrl.addParam({
      ...commonParams,
    })
  }

  return urlCreator
    .addQuery({ ...query }, { sort: false })
    .joinHash(hash)
    .toString()
}
